var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"offer-reporter",on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('WEBAPP_REPORT_BADOFFERS')))])
}
var staticRenderFns = []

export { render, staticRenderFns }